import React, { useMemo } from "react";
import { cloneDeep } from "lodash";
import { ProductRow } from "./components";
import { useSelector } from "react-redux";
import { getConventionProductsSelector } from "../../../../../../store/conventionsSlice";
import { getSelfServiceCnameSelector } from "../../../../../../store/selfServiceSlice";
import { productSort } from "../../../../../../utils";
import "./index.scss";

/**
 * @desc Product Table for Self Service Form.
 */
export const ProductTable = () => {
  // CONSTANTS ----------------------------------------------------------------

  const cname = useSelector(getSelfServiceCnameSelector);
  const conventionProductsSelector = useMemo(
    () => getConventionProductsSelector(cname),
    [cname]
  );
  const products = useSelector(conventionProductsSelector);
  const productRowEls = cloneDeep(products)
    .sort(productSort)
    .map((product) => (
      <ProductRow product={product} key={`${cname}-${product.sku}`} />
    ));

  // COMPONENT ----------------------------------------------------------------

  if (!productRowEls.length) return;

  return (
    <table className="product-table">
      <thead>
        <tr className="table-labels">
          <th>ITEM #</th>
          <th>PRODUCT IMAGE</th>
          <th>PRODUCT DETAILS</th>
          <th>SOLD OUT?</th>
          <th>DELETE ITEM</th>
        </tr>
      </thead>
      <tbody>{productRowEls}</tbody>
    </table>
  );
};
